var map = {
	"./addtohomescreen.png": 140,
	"./alert.png": 656,
	"./amazon.png": 657,
	"./background.png": 207,
	"./bakery_and_bread@3x.png": 201,
	"./beverages@3x.png": 658,
	"./beverages_GC@3x.png": 659,
	"./chart-bg.png": 660,
	"./chart-icons2.png": 661,
	"./dairy_and_eggs@3x.png": 662,
	"./deli@3x.png": 663,
	"./disappointed-face.png": 664,
	"./dummy.png": 665,
	"./empty-list.png": 114,
	"./food.png": 211,
	"./frozen@3x.png": 666,
	"./instacart.png": 212,
	"./logo.png": 208,
	"./meal.png": 667,
	"./meals@3x.png": 668,
	"./meat@3x.png": 669,
	"./miscellaneous_food_category_GC@3x.png": 670,
	"./neutral-face.png": 671,
	"./new_logo@3x.png": 213,
	"./no-image.png": 28,
	"./pantry@3x.png": 672,
	"./produce@3x.png": 673,
	"./profile.png": 674,
	"./seafood@3x.png": 675,
	"./smiling-face.png": 676,
	"./stories.png": 677,
	"./team/barry@3x.png": 214,
	"./team/doug@3x.png": 215,
	"./team/galen@3x.png": 216,
	"./team/harsh@3x.png": 217,
	"./team/jimmy@3x.png": 218,
	"./team/marc@3x.png": 219,
	"./team/paul@3x.png": 220,
	"./team/varun@3x.png": 221,
	"./team/zeeshan@3x.png": 678,
	"./team_image.png": 222,
	"./three-bunnies-803051-unsplash@3x.png": 679
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;


//////////////////
// WEBPACK FOOTER
// ./src/static/images ^\.\/.*$
// module id = 655
// module chunks = 1